(() => {
  if (window.__cloudXImageLightboxLoaded) return;
  window.__cloudXImageLightboxLoaded = true;

  const ACTIVE_HERO_IMAGE_SELECTOR = '.cloud-x-module--hero [data-cloud-x-product-media].active[data-cloud-x-media-type="image"] > img';
  const MOVE_TOLERANCE = 8;
  const ZOOM_SCALE = 2.4;
  const MAX_PINCH_SCALE = 4;
  const LIGHTBOX_TRANSITION_MS = 360;

  let lightbox = null;
  let viewport = null;
  let viewerImage = null;
  let prevButton = null;
  let nextButton = null;
  let closeButton = null;
  let currentHero = null;
  let currentEntries = [];
  let currentIndex = 0;
  let previousFocus = null;

  let scale = 1;
  let panX = 0;
  let panY = 0;
  let zoomPointer = null;
  let zoomPointerMoved = false;
  let suppressZoomClick = false;
  let touchDrag = null;
let pinchGesture = null;
let touchGestureMoved = false;
  let heroPress = null;
  let transitioning = false;

  const escapeSelector = (value) => {
    if (window.CSS?.escape) return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, '\\$&');
  };

  const isOpen = () => Boolean(lightbox && !lightbox.hidden);

  const getRoot = (hero) => hero?.closest('.cloud-x-pdp');

  const getImageEntries = (hero, clickedItem = null) => {
    if (!hero) return [];
    const mediaItems = [...hero.querySelectorAll('[data-cloud-x-product-media][data-cloud-x-media-type="image"]')]
      .filter((item) => item.dataset.cloudXGalleryVisible === 'true' || item === clickedItem);
    const thumbs = [...hero.querySelectorAll('.thumb[data-mode]')];
    const entries = [];
    const seen = new Set();

    thumbs.forEach((thumb) => {
      const mode = thumb.dataset.mode;
      if (!mode) return;
      const item = mediaItems.find((candidate) => candidate.dataset.cloudXMediaMode === mode);
      if (!item || seen.has(item)) return;
      seen.add(item);
      entries.push({ item, thumb });
    });

    mediaItems.forEach((item) => {
      if (seen.has(item)) return;
      seen.add(item);
      entries.push({ item, thumb: null });
    });

    if (clickedItem && !entries.some((entry) => entry.item === clickedItem)) {
      entries.unshift({ item: clickedItem, thumb: null });
    }

    return entries;
  };

  const getSource = (item) => {
    const img = item?.querySelector('img');
    return item?.dataset.cloudXZoomSrc || img?.currentSrc || img?.src || '';
  };

  const waitForImageReady = async (image) => {
    if (!image) return;
    if (image.complete && image.naturalWidth > 0) {
      try { await image.decode?.(); } catch { /* Decoding is an enhancement. */ }
      return;
    }
    await new Promise((resolve) => {
      const done = () => resolve();
      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
    });
  };

  const waitForHeroMediaSettled = async (item) => {
  if (!item) return;

  const animations =
    typeof item.getAnimations === 'function'
      ? item.getAnimations().filter(
          (animation) => animation.playState === 'running'
        )
      : [];

  if (animations.length) {
    await Promise.race([
      Promise.allSettled(
        animations.map((animation) => animation.finished)
      ),
      new Promise((resolve) => {
        window.setTimeout(resolve, 340);
      })
    ]);
  }

  await new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });
};
  const renderedImageRect = (image) => {
    if (!image) return null;
    const rect = image.getBoundingClientRect();
    if (!rect.width || !rect.height) return rect;
    const naturalWidth = image.naturalWidth || rect.width;
    const naturalHeight = image.naturalHeight || rect.height;
    if (!naturalWidth || !naturalHeight) return rect;
    const style = window.getComputedStyle(image);
    if (style.objectFit !== 'contain') return rect;
    const ratio = Math.min(rect.width / naturalWidth, rect.height / naturalHeight);
    const width = naturalWidth * ratio;
    const height = naturalHeight * ratio;
    return {
      left: rect.left + (rect.width - width) / 2,
      top: rect.top + (rect.height - height) / 2,
      right: rect.left + (rect.width + width) / 2,
      bottom: rect.top + (rect.height + height) / 2,
      width,
      height,
      x: rect.left + (rect.width - width) / 2,
      y: rect.top + (rect.height - height) / 2
    };
  };

  const isPointInsideRenderedImage = (x, y) => {
  const rect = renderedImageRect(viewerImage);

  if (!rect) return false;

  return (
    x >= rect.left &&
    x <= rect.right &&
    y >= rect.top &&
    y <= rect.bottom
  );
};

  const flipTransform = (fromRect, toRect) => {
    if (!fromRect || !toRect || !fromRect.width || !toRect.width) return null;
    const fromCenterX = fromRect.left + fromRect.width / 2;
    const fromCenterY = fromRect.top + fromRect.height / 2;
    const toCenterX = toRect.left + toRect.width / 2;
    const toCenterY = toRect.top + toRect.height / 2;
    const scaleValue = Math.max(.01, Math.min(20, fromRect.width / toRect.width));
    return {
      x: fromCenterX - toCenterX,
      y: fromCenterY - toCenterY,
      scale: scaleValue
    };
  };

  const currentSourceImage = () => currentEntries[currentIndex]?.item?.querySelector('img') || null;

  const finishTransition = () => {
    transitioning = false;
    lightbox?.classList.remove('is-transitioning', 'is-entering', 'is-leaving');
    if (viewerImage) viewerImage.style.transition = '';
  };

  const animateOpenFrom = async (sourceImage) => {
    if (!lightbox || !viewerImage || !sourceImage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishTransition();
      closeButton?.focus?.({ preventScroll: true });
      return;
    }
    await waitForImageReady(viewerImage);
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    const sourceRect = renderedImageRect(sourceImage);
    const targetRect = viewerImage.getBoundingClientRect();
    const flip = flipTransform(sourceRect, targetRect);
    if (!flip) {
      finishTransition();
      closeButton?.focus?.({ preventScroll: true });
      return;
    }

    viewerImage.style.transition = 'none';
    viewerImage.style.transform = `translate3d(${flip.x}px, ${flip.y}px, 0) scale(${flip.scale})`;
    viewerImage.getBoundingClientRect();
    viewerImage.style.transition = `transform ${LIGHTBOX_TRANSITION_MS}ms cubic-bezier(.22,1,.36,1)`;
    requestAnimationFrame(() => {
      lightbox.classList.remove('is-entering');
      viewerImage.style.transform = 'translate3d(0,0,0) scale(1)';
    });

    window.setTimeout(() => {
      finishTransition();
      closeButton?.focus?.({ preventScroll: true });
    }, LIGHTBOX_TRANSITION_MS + 30);
  };

  const setTransform = (animate = true) => {
    if (!viewerImage || !lightbox) return;
    lightbox.classList.toggle('is-zoomed', scale > 1);
    viewerImage.style.transition = animate ? '' : 'none';
    viewerImage.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${scale})`;
  };

  const clampPan = () => {
    if (!viewerImage || !viewport || scale <= 1) {
      panX = 0;
      panY = 0;
      return;
    }
    const maxX = Math.max(0, (viewerImage.offsetWidth * scale - viewport.clientWidth) / 2);
    const maxY = Math.max(0, (viewerImage.offsetHeight * scale - viewport.clientHeight) / 2);
    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
  };

  const resetZoom = (animate = true) => {
    scale = 1;
    panX = 0;
    panY = 0;
    zoomPointer = null;
    zoomPointerMoved = false;
    suppressZoomClick = false;
    touchDrag = null;
pinchGesture = null;
touchGestureMoved = false;
    lightbox?.classList.remove('is-dragging', 'is-zoomed');
    setTransform(animate);
  };

  const zoomIn = () => {
    scale = ZOOM_SCALE;
    panX = 0;
    panY = 0;
    clampPan();
    setTransform(true);
  };

  const updateNavState = () => {
    if (!prevButton || !nextButton || !currentHero) return;
    const shouldLoop = getRoot(currentHero)?.dataset.cloudXLoop !== 'false';
    const multiple = currentEntries.length > 1;
    prevButton.hidden = !multiple;
    nextButton.hidden = !multiple;
    prevButton.disabled = !multiple || (!shouldLoop && currentIndex <= 0);
    nextButton.disabled = !multiple || (!shouldLoop && currentIndex >= currentEntries.length - 1);
  };

  const renderCurrent = () => {
    const entry = currentEntries[currentIndex];
    if (!entry || !viewerImage) return;

    resetZoom(false);
    if (entry.thumb && !entry.thumb.classList.contains('active')) entry.thumb.click();

    const sourceImage = entry.item.querySelector('img');
    const source = getSource(entry.item);
    if (!source) return;

    viewerImage.alt = sourceImage?.alt || '';
    viewerImage.src = source;
    updateNavState();
  };

  const navigate = (direction) => {
    if (currentEntries.length < 2 || !currentHero) return;
    const shouldLoop = getRoot(currentHero)?.dataset.cloudXLoop !== 'false';
    let nextIndex = currentIndex + direction;
    if (shouldLoop) nextIndex = (nextIndex + currentEntries.length) % currentEntries.length;
    else nextIndex = Math.max(0, Math.min(currentEntries.length - 1, nextIndex));
    if (nextIndex === currentIndex) return;
    currentIndex = nextIndex;
    renderCurrent();
  };

  const finalizeClose = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cloud-x-image-lightbox-open');
    resetZoom(false);
    viewerImage?.removeAttribute('src');
    currentHero = null;
    currentEntries = [];
    currentIndex = 0;
    finishTransition();
    previousFocus?.focus?.({ preventScroll: true });
    previousFocus = null;
  };

  const close = async () => {
    if (!isOpen() || transitioning) return;
    transitioning = true;
    lightbox.classList.add('is-transitioning', 'is-leaving');
    resetZoom(false);

    const destinationImage = currentSourceImage();
    if (!viewerImage || !destinationImage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setTimeout(finalizeClose, 80);
      return;
    }

    await waitForImageReady(viewerImage);
    await new Promise((resolve) => requestAnimationFrame(resolve));
    const startRect = viewerImage.getBoundingClientRect();
    const destinationRect = renderedImageRect(destinationImage);
    const flip = flipTransform(destinationRect, startRect);
    if (!flip) {
      window.setTimeout(finalizeClose, 80);
      return;
    }

    viewerImage.style.transition = `transform ${LIGHTBOX_TRANSITION_MS}ms cubic-bezier(.64,0,.78,0)`;
    viewerImage.style.transform = `translate3d(${flip.x}px, ${flip.y}px, 0) scale(${flip.scale})`;
    window.setTimeout(finalizeClose, LIGHTBOX_TRANSITION_MS + 30);
  };

  const ensureLightbox = () => {
    if (lightbox) return;

    lightbox = document.createElement('div');
    lightbox.className = 'cloud-x-image-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product image viewer');
    lightbox.innerHTML = `
      <div class="cloud-x-image-lightbox-controls" aria-label="Image viewer controls">
        <button type="button" class="cloud-x-image-lightbox-button" data-cloud-x-lightbox-prev aria-label="Previous image">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>
        </button>
        <button type="button" class="cloud-x-image-lightbox-button" data-cloud-x-lightbox-next aria-label="Next image">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>
        </button>
        <button type="button" class="cloud-x-image-lightbox-button" data-cloud-x-lightbox-close aria-label="Close image viewer">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>
        </button>
      </div>
      <div class="cloud-x-image-lightbox-viewport" data-cloud-x-lightbox-viewport>
        <img class="cloud-x-image-lightbox-image" alt="" draggable="false">
      </div>`;

    document.body.append(lightbox);
    viewport = lightbox.querySelector('[data-cloud-x-lightbox-viewport]');
    viewerImage = lightbox.querySelector('.cloud-x-image-lightbox-image');
    prevButton = lightbox.querySelector('[data-cloud-x-lightbox-prev]');
    nextButton = lightbox.querySelector('[data-cloud-x-lightbox-next]');
    closeButton = lightbox.querySelector('[data-cloud-x-lightbox-close]');

    prevButton.addEventListener('click', () => navigate(-1));
    nextButton.addEventListener('click', () => navigate(1));
    closeButton.addEventListener('click', close);

    lightbox.addEventListener('click', (event) => {
      if (transitioning) return;
      if (event.target === lightbox || event.target === viewport) close();
    });

    viewerImage.addEventListener('click', (event) => {
  if (suppressZoomClick) return;

  /*
   * The <img> element itself fills the lightbox,
   * but object-fit: contain creates white letterbox space.
   * Clicking that white space should close the lightbox.
   */
  if (
    scale <= 1 &&
    !isPointInsideRenderedImage(event.clientX, event.clientY)
  ) {
    close();
    return;
  }

  /*
   * Clicking the real image keeps the current behavior:
   * normal → zoom in
   * zoomed → reset
   */
  if (scale > 1) {
    resetZoom(true);
  } else {
    zoomIn();
  }
});

    /*
 * Desktop:
 * Mouse drag while the image is zoomed.
 */
viewerImage.addEventListener('pointerdown', (event) => {
  if (event.pointerType !== 'mouse') return;

  if (scale <= 1 || event.button !== 0) return;

  zoomPointer = {
    id: event.pointerId,
    startX: event.clientX,
    startY: event.clientY,
    originX: panX,
    originY: panY
  };

  zoomPointerMoved = false;

  viewerImage.setPointerCapture?.(event.pointerId);

  lightbox.classList.add('is-dragging');
});


viewerImage.addEventListener('pointermove', (event) => {
  if (event.pointerType !== 'mouse') return;

  if (
    !zoomPointer ||
    zoomPointer.id !== event.pointerId ||
    scale <= 1
  ) {
    return;
  }

  const dx = event.clientX - zoomPointer.startX;
  const dy = event.clientY - zoomPointer.startY;

  if (Math.hypot(dx, dy) > 4) {
    zoomPointerMoved = true;
  }

  panX = zoomPointer.originX + dx;
  panY = zoomPointer.originY + dy;

  clampPan();

  setTransform(false);
});


const finishZoomDrag = (event) => {
  if (event.pointerType !== 'mouse') return;

  if (
    !zoomPointer ||
    zoomPointer.id !== event.pointerId
  ) {
    return;
  }

  const moved = zoomPointerMoved;

  zoomPointer = null;
  zoomPointerMoved = false;

  suppressZoomClick = moved;

  if (
    viewerImage.hasPointerCapture?.(event.pointerId)
  ) {
    viewerImage.releasePointerCapture(event.pointerId);
  }

  lightbox.classList.remove('is-dragging');

  viewerImage.style.transition = '';

  if (suppressZoomClick) {
    window.setTimeout(() => {
      suppressZoomClick = false;
    }, 0);
  }
};


viewerImage.addEventListener(
  'pointerup',
  finishZoomDrag
);

viewerImage.addEventListener(
  'pointercancel',
  finishZoomDrag
);

viewerImage.addEventListener(
  'lostpointercapture',
  finishZoomDrag
);


/*
 * Mobile:
 * 1 finger = drag while zoomed
 * 2 fingers = pinch zoom
 */
viewerImage.addEventListener(
  'touchstart',
  (event) => {

    /* ---------- Pinch start ---------- */

    if (event.touches.length === 2) {

      event.preventDefault();

      const a = event.touches[0];
      const b = event.touches[1];

      const centerX =
        (a.clientX + b.clientX) / 2;

      const centerY =
        (a.clientY + b.clientY) / 2;

      const viewportRect =
        viewport.getBoundingClientRect();

      pinchGesture = {
        distance: Math.max(
          1,
          Math.hypot(
            b.clientX - a.clientX,
            b.clientY - a.clientY
          )
        ),

        scale,

        panX,
        panY,

        centerX,
        centerY,

        viewportCenterX:
          viewportRect.left +
          viewportRect.width / 2,

        viewportCenterY:
          viewportRect.top +
          viewportRect.height / 2
      };

      touchDrag = null;

      touchGestureMoved = true;

      suppressZoomClick = true;

      lightbox.classList.add('is-dragging');

      viewerImage.style.transition = 'none';

      return;
    }


    /* ---------- One finger drag ---------- */

    if (
      event.touches.length === 1 &&
      scale > 1
    ) {

      const touch = event.touches[0];

      touchDrag = {
        startX: touch.clientX,
        startY: touch.clientY,
        originX: panX,
        originY: panY
      };

      touchGestureMoved = false;

      lightbox.classList.add('is-dragging');
    }

  },
  { passive: false }
);


/*
 * Mobile touch move
 */
viewerImage.addEventListener(
  'touchmove',
  (event) => {

    /* ---------- Pinch Zoom ---------- */

    if (
      event.touches.length === 2 &&
      pinchGesture
    ) {

      event.preventDefault();

      const a = event.touches[0];
      const b = event.touches[1];

      const distance = Math.max(
        1,
        Math.hypot(
          b.clientX - a.clientX,
          b.clientY - a.clientY
        )
      );

      const centerX =
        (a.clientX + b.clientX) / 2;

      const centerY =
        (a.clientY + b.clientY) / 2;


      /*
       * Scale according to finger distance.
       */
      const nextScale = Math.max(
        1,
        Math.min(
          MAX_PINCH_SCALE,

          pinchGesture.scale *
          (
            distance /
            pinchGesture.distance
          )
        )
      );


      const ratio =
        nextScale /
        pinchGesture.scale;


      scale = nextScale;


      /*
       * Keep the area between the two fingers
       * visually under the fingers while zooming.
       */
      panX =
        centerX -
        pinchGesture.viewportCenterX -
        (
          pinchGesture.centerX -
          pinchGesture.viewportCenterX -
          pinchGesture.panX
        ) *
        ratio;


      panY =
        centerY -
        pinchGesture.viewportCenterY -
        (
          pinchGesture.centerY -
          pinchGesture.viewportCenterY -
          pinchGesture.panY
        ) *
        ratio;


      touchGestureMoved = true;

      suppressZoomClick = true;

      clampPan();

      setTransform(false);

      return;
    }


    /* ---------- One finger drag ---------- */

    if (
      event.touches.length === 1 &&
      touchDrag &&
      scale > 1
    ) {

      event.preventDefault();

      const touch =
        event.touches[0];

      const dx =
        touch.clientX -
        touchDrag.startX;

      const dy =
        touch.clientY -
        touchDrag.startY;


      if (
        Math.hypot(dx, dy) > 4
      ) {
        touchGestureMoved = true;
      }


      panX =
        touchDrag.originX + dx;

      panY =
        touchDrag.originY + dy;


      clampPan();

      setTransform(false);
    }

  },
  { passive: false }
);


/*
 * Touch finish
 */
const finishTouchGesture = (event) => {

  const hadGesture = Boolean(
    pinchGesture ||
    touchDrag ||
    touchGestureMoved
  );


  /*
   * Pinch ends with one finger remaining:
   * immediately switch to one-finger drag.
   */
  if (
    event.touches.length === 1 &&
    scale > 1
  ) {

    const touch =
      event.touches[0];

    pinchGesture = null;

    touchDrag = {
      startX: touch.clientX,
      startY: touch.clientY,
      originX: panX,
      originY: panY
    };

    suppressZoomClick = true;

    return;
  }


  if (
    event.touches.length > 0
  ) {
    return;
  }


  pinchGesture = null;
  touchDrag = null;


  lightbox.classList.remove(
    'is-dragging'
  );


  viewerImage.style.transition = '';


  /*
   * If user pinches almost all the way back,
   * snap cleanly to the original size.
   */
  if (scale <= 1.02) {

    resetZoom(true);

  } else {

    clampPan();

    setTransform(false);

  }


  /*
   * Prevent pinch / drag from being interpreted
   * as a normal image click afterwards.
   */
  if (hadGesture) {

    suppressZoomClick = true;

    window.setTimeout(() => {
      suppressZoomClick = false;
    }, 300);

  }


  touchGestureMoved = false;
};


viewerImage.addEventListener(
  'touchend',
  finishTouchGesture,
  { passive: false }
);


viewerImage.addEventListener(
  'touchcancel',
  finishTouchGesture,
  { passive: false }
);
};

  const openFromImage = async (sourceImage) => {
    const hero = sourceImage?.closest('.cloud-x-module--hero');
    const item = sourceImage?.closest('[data-cloud-x-product-media]');
    if (!hero || !item || item.dataset.cloudXMediaType !== 'image' || transitioning) return;
await waitForHeroMediaSettled(item);

if (!sourceImage.matches(ACTIVE_HERO_IMAGE_SELECTOR)) return;
    ensureLightbox();
    transitioning = true;
    currentHero = hero;
    currentEntries = getImageEntries(hero, item);
    currentIndex = Math.max(0, currentEntries.findIndex((entry) => entry.item === item));
    previousFocus = document.activeElement;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.classList.add('is-transitioning', 'is-entering');
    document.body.classList.add('cloud-x-image-lightbox-open');
    renderCurrent();
    await animateOpenFrom(sourceImage);
  };

  document.addEventListener('pointerdown', (event) => {
    const image = event.target.closest?.(ACTIVE_HERO_IMAGE_SELECTOR);
    if (!image) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    heroPress = {
      id: event.pointerId,
      image,
      startX: event.clientX,
      startY: event.clientY,
      moved: false
    };
  }, true);

  document.addEventListener('pointermove', (event) => {
    if (!heroPress || heroPress.id !== event.pointerId) return;
    if (Math.hypot(event.clientX - heroPress.startX, event.clientY - heroPress.startY) > MOVE_TOLERANCE) {
      heroPress.moved = true;
    }
  }, true);

  document.addEventListener('pointerup', (event) => {
    if (!heroPress || heroPress.id !== event.pointerId) return;
    const press = heroPress;
    heroPress = null;
    const moved = press.moved || Math.hypot(event.clientX - press.startX, event.clientY - press.startY) > MOVE_TOLERANCE;
    if (moved) return;
    window.setTimeout(() => {
      if (!isOpen() && press.image.matches(ACTIVE_HERO_IMAGE_SELECTOR)) openFromImage(press.image);
    }, 0);
  }, true);

  document.addEventListener('pointercancel', (event) => {
    if (heroPress?.id === event.pointerId) heroPress = null;
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;
    if (event.key === 'Escape') close();
    else if (event.key === 'ArrowLeft') navigate(-1);
    else if (event.key === 'ArrowRight') navigate(1);
  });

  window.addEventListener('resize', () => {
    if (!isOpen() || scale <= 1) return;
    clampPan();
    setTransform(false);
  }, { passive: true });
})();
